module.exports = __webpack_public_path__ + "media/images/default/shared/footer/bg-lg-ec6b4640f3e98da0e462c59fa8863f68.svg";